// Deployment configuration - injected at build time
export const DEPLOYMENT_CONFIG = {
  type: 'singleapp-public',
  defaultApp: 'shop',
  apiUrl: 'https://ws4kgmpzaj.execute-api.us-east-1.amazonaws.com/prod'
};
